<div *ngIf="typeList && dataCategories">
    <br>
    <br>
    
    <nb-form-field class="cat-dropdown">
        <nb-select [(ngModel)]="selectedType" [placeholder]="'type'| translation" >
            <nb-option *ngFor="let type of typeList" [value]="type">{{type.name}}</nb-option>
        </nb-select>
    </nb-form-field>


    <nb-form-field class="cat-dropdown">
        <nb-select [placeholder]="'category'| translation" *ngIf="!selectedType">
        </nb-select>

        <nb-select [(ngModel)]="selectedType.category" [placeholder]="'category'| translation" (selectedChange)=updateCategory() *ngIf="selectedType">
            <nb-option *ngFor="let category of dataCategories" [value]="category.id">{{category.title}}</nb-option>
        </nb-select>
    </nb-form-field>

</div>
